/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import moment from 'moment';
import WyUtils from './wy-utils.js';

export default (function () {
  this.dateRangeTypes = {
    'year': {
      type: 'year',
      label: 'View by year',
      tickformat: '%Y',
      disabled: true,
      duraion: 99999
    },
    'month': {
      type: 'month',
      label: 'View by month',
      tickformat: '%b %Y',
      disabled: true,
      duraion: 365
    },
    'week': {
      type: 'week', 
      label: 'View by week',
      tickformat: '%b %d %Y',
      disabled: true,
      duraion: 30
    },
    'day': {
      type: 'day',
      label: 'View by day',
      tickformat: '%b %d %Y',
      disabled: true,
      duraion: 7
    }
  };

  this.dateRange = null;
  this.dateRangeDatesDiff = 0;
  //this.dateRangeMonthsDiff = 0;
  //this.dateRangeQuarterDiff = 0;
  this.selectedDateRange = 'day';
  this.autoDateRange = true;
  
  this.init = function(type, dateStart, dateEnd, dRangeTypes, chartViewBy) {
    let dateStartMoment = moment(dateStart,'YYYY-MM-DD');
    let dateEndMoment = moment(dateEnd,'YYYY-MM-DD');
    this.dateRangeDatesDiff = dateEndMoment.diff(dateStartMoment, 'days', true) + 1;
    //this.dateRangeMonthsDiff = dateEndMoment.diff(dateStartMoment, 'months', true);  
    //this.dateRangeQuarterDiff = dateEndMoment.diff(dateStartMoment, 'months', true);  

    // orverride default date range types
    if(dRangeTypes) {
      this.dateRangeTypes = dRangeTypes;
    }

    if(this.dateRangeDatesDiff < 7) {
      this.autoDateRange = false;
      dateStart = dateStartMoment.subtract(3, 'd').format('YYYY-MM-DD');
      dateEnd = dateEndMoment.add(3, 'd').format('YYYY-MM-DD');
    }
    else {
      this.autoDateRange = true;
    }
    this.dateRange = [dateStart, dateEnd];

    const sortedDateRangeTypes = Object.values(this.dateRangeTypes).sort((a, b) => (a.duraion - b.duraion));
    // enable avaliable date range type
    for(const item of sortedDateRangeTypes) {
      if(this.dateRangeDatesDiff < item.duraion) {
        item.disabled = false;
        // reset the other items
        sortedDateRangeTypes.filter(otherItem => otherItem.type!=item.type).map(otherItem => {
          otherItem.disabled = (otherItem.duraion > item.duraion);
        });
        break;
      }
    }

    if(type) {
      this.selectedDateRange = type;
    }
    else if(chartViewBy && typeof chartViewBy === 'string') {
      this.selectedDateRange = chartViewBy
    }
    else if(this.dateRangeTypes.day && !this.dateRangeTypes.day.disabled && chartViewBy && chartViewBy.dailyWithinDays && this.dateRangeDatesDiff <= chartViewBy.dailyWithinDays) {
      this.selectedDateRange = 'day'
    }
    else if(this.dateRangeTypes.week && !this.dateRangeTypes.week.disabled && chartViewBy && chartViewBy.weeklyWithinDays && this.dateRangeDatesDiff <= chartViewBy.weeklyWithinDays) {
      this.selectedDateRange = 'week'
    }
    else if(this.dateRangeTypes.month && !this.dateRangeTypes.month.disabled && chartViewBy && chartViewBy.monthlyWithinDays && this.dateRangeDatesDiff <= chartViewBy.monthlyWithinDays) {
      this.selectedDateRange = 'month'
    }
    else if(this.dateRangeTypes.quarter && !this.dateRangeTypes.quarter.disabled && chartViewBy && chartViewBy.quarterlyWithinDays && this.dateRangeDatesDiff <= chartViewBy.quarterlyWithinDays) {
      this.selectedDateRange = 'quarter'
    }
    else if(this.dateRangeTypes.year && !this.dateRangeTypes.year.disabled && chartViewBy && chartViewBy.yearlyWithinDays && this.dateRangeDatesDiff <= chartViewBy.yearlyWithinDays) {
      this.selectedDateRange = 'year'
    }
    else {
      // get default date range type      
      for(const item of sortedDateRangeTypes) {
        if(this.dateRangeDatesDiff < item.duraion) {
          this.selectedDateRange = item.type;
          break;
        }
      }
    }
  }

  this.getDateRangeTypes = function() {
    return Object.values(this.dateRangeTypes);
  },

  this.getDateRangeType = function() {
    return this.dateRangeTypes[this.selectedDateRange];
  }

  this.prepareGroupDates = function(item, date) {
    // prepare date types
    let dateObj = moment(date,'YYYY-MM-DD');
    item.day = date;
    item.year = dateObj.format('YYYY');
    item.month = dateObj.format('YYYY-MM');
    item.week = dateObj.format('gggg-w');
    item.quarter = dateObj.format('YYYY') + "-" +moment(date).quarter()
  }


  this.groupBy = function(dataItems, funCal) {
    // eslint-disable-next-line no-undef
    const dataList = _(dataItems)
      .groupBy(this.selectedDateRange)
      .map((items) => (funCal(items)))
      .value()

    return dataList;
  }

  this.hoverTemplate = function(format) {
    if(format == 's' || format == 'm') {
      return "Date: %{x}<br>Time: %{hovertext}<extra></extra>";
    } 
    else if(format == '%') {
      return "Date: %{x}<br>Total: %{hovertext}%<extra></extra>";
    }
    else {
      return "Date: %{x}<br>Total: %{hovertext}<extra></extra>";
    }
  }

  this.hoverTemplateMedian = function(format) {
    if(format == 's' || format == 'm') {
      return "Date: %{x}<br>Median: %{text}<br>Time: %{hovertext}<extra></extra>";
    } 
    else if(format == '%') {
      return "Date: %{x}<br>Median: %{text}%<br>Total: %{hovertext}%<extra></extra>";
    }
    else {
      return "Date: %{x}<br>Median: %{text}<br>Total: %{hovertext}<extra></extra>";
    }
  }


  this.hoverTemplateNoDate = function(format) {
    if(format == 's' || format == 'm') {
      return "%{hovertext}<extra></extra>";
    } 
    else if(format == '%') {
      return "%{hovertext}%<extra></extra>";
    }
    else {
      return "%{hovertext}<extra></extra>";
    }
  }

  this.calTicks = function(val, maxLabels=6) {
    val--;
    //val = maxLabels + (val % maxLabels);    
    let primeNumbers = [11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97];
    if(primeNumbers.includes(val)) {
      val++;
    }

    let numOfTicks = 0;
    for(var i=0; i < maxLabels; i++) {      
      if(val % (maxLabels-i) == 0) {
        numOfTicks = (val / (maxLabels-i));
        break;
      }
    }
    return numOfTicks;
  }

  this.finalizeChart = function(traces, layout, maxYValue) {
    let yAxisMaxValue = 0;
    if(maxYValue) {
      yAxisMaxValue = maxYValue;
    }
    else {
      traces.forEach(trace => {
        if(trace && Array.isArray(trace.y) && trace.y.length > 0) {
          let maxValue = trace.y.reduce((max, val) => {
            return (val > max) ? val : max;
          })
          if(maxValue > yAxisMaxValue) {
            yAxisMaxValue = maxValue;
          }
        }
      });
    }

    let suffix = layout.yaxis.ticksuffix.trim();
    if(suffix == 'm' && yAxisMaxValue < 1) {
      traces.forEach(trace => {
        if(trace && Array.isArray(trace.y) && trace.y.length > 0) {
          trace.y.forEach((val, index) => {
            trace.y[index] = val * 60;
          })
        }
      });
    }
    
    if(!this.autoDateRange) {
      layout.xaxis.autorange = false;
      layout.xaxis.range = this.dateRange;
    }

    if(maxYValue) {
      layout.yaxis.autorange = false;
      layout.yaxis.range = [0, maxYValue];
    }
    
    if(suffix == '%') {
      layout.yaxis.autorange = false;
      layout.yaxis.range = (layout.yaxis.rangePercent ? layout.yaxis.rangePercent : [0, 100]);
    }
    else if(suffix == 'm' && yAxisMaxValue < 1) {
      layout.yaxis.autorange = false;
      layout.yaxis.range = (layout.yaxis.rangeSecond ? layout.yaxis.rangeSecond : [0, 60]);
      layout.yaxis.ticksuffix = 's ';
    }
    else if(yAxisMaxValue < 5) {
      layout.yaxis.autorange = false;
      layout.yaxis.range = [0, 5];
    }
  }

  this.prepareRegressionData = function(list, {format}) {
    let medianValue = WyUtils.findMedian(list.map(el => el.value))

    let data = {
      x: [], y: [], texts: [], medianTexts: [], markerColor: [], minValue: 0, maxValue: 0
    }
    let regressionData = {
      x: 0, y: 0, xy: 0, xx: 0, a: 0, b: 0, n: 0, xValues: [], yValues: []
    }
    let medianData = {
      x: [], y: []
    }
    
    regressionData.n = list.length;

    list.forEach((item, xValue) => {
      let dataValue = item.value;

      if(xValue == 0) data.minValue = dataValue;

      // set x value
      data.x.push(item.date);
      data.y.push(dataValue);
      //data.markerSize.push(0);
      data.markerColor.push("transparent");
      if(format == 'time') {
        data.texts.push(WyUtils.toNiceTimeFormatFromMinus(dataValue));
        data.medianTexts.push(WyUtils.toNiceTimeFormatFromMinus(medianValue));
      }
      else {
        data.medianTexts.push(WyUtils.formatterNumber(medianValue));
        if(item.partialDateRangeFlag){
          data.texts.push(WyUtils.formatterNumber(dataValue)+'<br>Partial date range');
        }else{
          data.texts.push(WyUtils.formatterNumber(dataValue));
        }
      }

      medianData.x.push(item.date);
      medianData.y.push(medianValue);

      regressionData.x+= xValue;
      regressionData.y+= dataValue;
      regressionData.xy+= (xValue * dataValue);
      regressionData.xx+= (xValue * xValue);

      // cal min and max value
      if(data.minValue > dataValue) data.minValue = dataValue;
      if(data.maxValue < dataValue) data.maxValue = dataValue;
    });

    regressionData.a = ((regressionData.y * regressionData.xx) - (regressionData.x * regressionData.xy)) / ((regressionData.n * regressionData.xx) - (regressionData.x * regressionData.x));
    regressionData.b = ((regressionData.n * regressionData.xy) - (regressionData.x * regressionData.y)) / ((regressionData.n * regressionData.xx) - (regressionData.x * regressionData.x));

    list.forEach((item, xValue) => {
      let dataValue = regressionData.a + regressionData.b * xValue;
      if(dataValue >= 0) {
        regressionData.xValues.push(item.date);      
        regressionData.yValues.push(dataValue);
      }
    });

    return {
      data: data,
      regressionData: regressionData,
      medianData: medianData
    }
  }

  this.prepareRegressionDataByTrace = function({x, y}, {format}) {
    let medianValue = WyUtils.findMedian(y)

    let data = {
      x: [], y: [], texts: [], medianTexts: [], markerColor: [], minValue: 0, maxValue: 0
    }
    let regressionData = {
      x: 0, y: 0, xy: 0, xx: 0, a: 0, b: 0, n: 0, xValues: [], yValues: []
    }
    let medianData = {
      x: [], y: []
    }
    
    regressionData.n = x.length;

    x.forEach((itemDate, xValue) => {
      let dataValue = y[xValue];

      if(xValue == 0) data.minValue = dataValue;

      // set x value
      data.x.push(itemDate);
      data.y.push(dataValue);
      //data.markerSize.push(0);
      data.markerColor.push("transparent");
      if(format == 'time') {
        data.texts.push(WyUtils.toNiceTimeFormatFromMinus(dataValue));
        data.medianTexts.push(WyUtils.toNiceTimeFormatFromMinus(medianValue));
      }
      else {
        data.medianTexts.push(WyUtils.formatterNumber(medianValue));
        data.texts.push(WyUtils.formatterNumber(dataValue));
      }

      medianData.x.push(itemDate);
      medianData.y.push(medianValue);

      regressionData.x+= xValue;
      regressionData.y+= dataValue;
      regressionData.xy+= (xValue * dataValue);
      regressionData.xx+= (xValue * xValue);

      // cal min and max value
      if(data.minValue > dataValue) data.minValue = dataValue;
      if(data.maxValue < dataValue) data.maxValue = dataValue;
    });

    regressionData.a = ((regressionData.y * regressionData.xx) - (regressionData.x * regressionData.xy)) / ((regressionData.n * regressionData.xx) - (regressionData.x * regressionData.x));
    regressionData.b = ((regressionData.n * regressionData.xy) - (regressionData.x * regressionData.y)) / ((regressionData.n * regressionData.xx) - (regressionData.x * regressionData.x));

    x.forEach((itemDate, xValue) => {
      let dataValue = regressionData.a + regressionData.b * xValue;
      //if(dataValue >= 0) {
        regressionData.xValues.push(itemDate);      
        regressionData.yValues.push(dataValue);
      //}
    });

    return {
      data: data,
      regressionData: regressionData,
      medianData: medianData
    }
  }

  this.finalizeRegressionChart = function(traces, layout, format, {minYValue, maxYValue}) {
    let yAxisMaxValue = 0;

    if(minYValue != null && maxYValue != null) {
      yAxisMaxValue = maxYValue;
    }
    else if(traces.length > 0) {
      let trace = traces[0];
      if(Array.isArray(trace.y) && trace.y.length > 0) {
        let maxValue = trace.y.reduce((max, val) => { return (val > max) ? val : max; }, 0);
        if(maxValue > yAxisMaxValue) yAxisMaxValue = maxValue;
      }
    }

    if(format == 'time' && yAxisMaxValue < 1) {
      if(minYValue != null) minYValue = minYValue * 60;
      if(maxYValue != null) maxYValue = maxYValue * 60;

      if(traces.length > 0) {
        traces.forEach(trace => {
          if(trace && Array.isArray(trace.y) && trace.y.length > 0) {
            trace.y.forEach((val, index) => {
              trace.y[index] = val * 60;            
            });
            layout.yaxis.ticksuffix = 's';
          }
        });

        if(!(traces[0] && Array.isArray(traces[0].y) && traces[0].y.length > 0)) {
          minYValue = 0;
          maxYValue = 5; 
        }
      }      
    }
    
    if(!this.autoDateRange) {
      layout.xaxis.autorange = false;
      layout.xaxis.range = this.dateRange;
    }

    if((minYValue != null && minYValue > -1) && (maxYValue != null && maxYValue > 0)) {
      layout.yaxis.autorange = false;
      layout.yaxis.range = [minYValue, maxYValue];
    }
  }
});